/*
 * @Author: wangyunlin wangyunlin@morewis.com
 * @Date: 2022-10-29 14:15:11
 * @LastEditors: misslinge misslinge@126.com
 * @LastEditTime: 2023-06-22 13:17:13
 * @FilePath: \douyin\src\api\utils\wxConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import qs from  'qs' 
import { wxAuthCode } from '../api/api';


/**对应产品充值页面   .com抖音   .cn快手*/
const webSiteInfo = {
  'mvp.bxsvip.com': 'dy', // 抖音充值
  'vip.bxsvip.com': 'dyPlus', // 抖音充值(去掉7元)
  'm.bxsvip.com': 'dy4',
  'm.bxsvip.cn': 'ks2', // 快币充值
  'vip.bxsvip.cn': 'ks2',
};  




const WX_DATA = {
  // appid: 'wx5377e6b7811aedb0', // 百晓生
  // appid: 'wxdf8cd8dee821c0eb', // 好前程
  appid: 'wx32b2452f79e386f6', 
  redirect_uri: `https://mvp.bxsvip.com/#/${webSiteInfo[location.host]?? 'dy'}`,
  mchid: '',
  response_type: 'code',
  scope: 'snsapi_base', // snsapi_base 静默授权   snsapi_userinfo需要手动同意
};

// const toAuth = ()=> {
//   const queryObj = {
//     appid: WX_DATA.appid, // 测试
//     redirect_uri: WX_DATA.redirect_uri,
//     response_type: WX_DATA.response_type,
//     scope: WX_DATA.scope,
//   };
//   const queryUrl = qs.stringify(queryObj) + '#wechat_redirect'
//   const url = 'https://open.weixin.qq.com/connect/oauth2/authorize?' + queryUrl;
//   window.location.href = url;
// }

const getUrlCode = (name)=> {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}




const toAuth = ()=> {
    // 推广域名映射页面
    const webSiteList = {
        'mvp.bxsvip.com': {
            page: 'dy',
            orderType: '10',
        },
    }; 

    const webSiteInfo = webSiteList[location.host];
    const _oType = webSiteInfo?.orderType;
    const params = {
        orderType: _oType,
        redirectUri: encodeURIComponent(`https://mvp.bxsvip.com/#/${webSiteInfo?.page}?orderType=${_oType}`),
    };

    wxAuthCode(qs.stringify(params)).then((res) => {
        console.log(res);
        window.location.href = res;
    });
}



export {
  toAuth,
//   WX_DATA,
  getUrlCode
}